module.exports = __webpack_public_path__ + "static/marketperc-13e33096aa25e69eb8b5869a0c1b2823.png";